var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnalysis = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 20,
  viewBox: "0 0 22 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 19H21",
  stroke: "currentColor",
  strokeLinecap: "round"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 15.3889,
  y: 0.5,
  width: 2.88889,
  height: 16.3714,
  rx: 1.44444,
  stroke: "currentColor"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 15.3889,
  y: 0.5,
  width: 2.88889,
  height: 16.3714,
  rx: 1.44444,
  stroke: "currentColor"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 9.27777,
  y: 5.92859,
  width: 2.88889,
  height: 10.9429,
  rx: 1.44444,
  stroke: "currentColor"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 9.27777,
  y: 5.92859,
  width: 2.88889,
  height: 10.9429,
  rx: 1.44444,
  stroke: "currentColor"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 3.16669,
  y: 2.67145,
  width: 2.88889,
  height: 14.2,
  rx: 1.44444,
  stroke: "currentColor"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 3.16669,
  y: 2.67145,
  width: 2.88889,
  height: 14.2,
  rx: 1.44444,
  stroke: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnalysis);
export { ForwardRef as ReactComponent };